type ValidationIssue = {
  path?: unknown;
  message?: unknown;
};

const fieldLabel = (value: unknown) => {
  const field = Array.isArray(value) ? value.at(-1) : undefined;
  if (typeof field !== 'string' || !field) return 'Document metadata';
  const spaced = field.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
  return spaced.replace(/^./, letter => letter.toUpperCase());
};

const issueText = (issue: ValidationIssue) => {
  const label = fieldLabel(issue.path);
  const message = typeof issue.message === 'string' ? issue.message : 'is not valid';
  if (/invalid iso date/i.test(message)) return `${label} must be a valid date in YYYY-MM-DD format`;
  return `${label}: ${message}`;
};

export function friendlyDocumentError(value?: string) {
  if (!value) return '';
  try {
    const parsed: unknown = JSON.parse(value);
    const issues = Array.isArray(parsed) ? parsed : [parsed];
    const readable = issues
      .filter((issue): issue is ValidationIssue => Boolean(issue) && typeof issue === 'object')
      .map(issueText)
      .slice(0, 3);
    if (readable.length) return `Document metadata needs correction: ${readable.join('; ')}.`;
  } catch {
    // Provider errors that are already plain text remain unchanged.
  }
  return value;
}
